import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetSimXInstitutionReleaseTagsRequest } from '../models/requests/get-simx-institution-release-tags-request.model';
import { SetSimXInstitutionReleaseTagsRequest } from '../models/requests/set-simx-institution-release-tags-request.model';
import { GetSimXInstitutionReleaseTagsResponse } from '../models/responses/get-simx-institution-release-tags-response.model';
import { SetSimXInstitutionReleaseTagsResponse } from '../models/responses/set-simx-institution-release-tags-response.model';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class InstitutionReleaseTagDataService {
  private readonly _dataService = inject(DataService);
  private readonly _http = inject(HttpClient);

  getInstitutionReleaseTagsForInstitution(
    institutionId: string,
    request: GetSimXInstitutionReleaseTagsRequest,
  ): Observable<GetSimXInstitutionReleaseTagsResponse> {
    const url =
      this._dataService.institutionReleaseTagsForInstitutionUrl(institutionId);
    return this._http.post<GetSimXInstitutionReleaseTagsResponse>(url, request);
  }

  getInstitutionReleaseTagsForReleaseTag(
    releaseTagId: string,
    request: GetSimXInstitutionReleaseTagsRequest,
  ): Observable<GetSimXInstitutionReleaseTagsResponse> {
    const url =
      this._dataService.institutionReleaseTagsForReleaseTagUrl(releaseTagId);
    return this._http.post<GetSimXInstitutionReleaseTagsResponse>(url, request);
  }

  setInstitutionReleaseTagsForInstitution(
    institutionId: string,
    request: SetSimXInstitutionReleaseTagsRequest,
  ): Observable<SetSimXInstitutionReleaseTagsResponse> {
    const url =
      this._dataService.institutionReleaseTagsForInstitutionUrl(institutionId);
    return this._http.patch<SetSimXInstitutionReleaseTagsResponse>(
      url,
      request,
    );
  }

  setInstitutionReleaseTagsForReleaseTag(
    releaseTagId: string,
    request: SetSimXInstitutionReleaseTagsRequest,
  ): Observable<SetSimXInstitutionReleaseTagsResponse> {
    const url =
      this._dataService.institutionReleaseTagsForReleaseTagUrl(releaseTagId);
    return this._http.patch<SetSimXInstitutionReleaseTagsResponse>(
      url,
      request,
    );
  }
}
